import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** shadcn/ui cn helper. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
